import { formatCurrency } from '@chikara/utils';
import { ActivateCardState } from './activateCard.types';

export const CARD_NUMBER_LENGTH = 16;
export const CARD_MAX_LENGTH = 19;
export const DEFAULT_SPENDING_LIMIT = 30000;

export const STEP_DATA = 1;
export const STEP_LIMIT = 2;
export const STEP_CONFIRMATION = 3;

export const getInitialState = (userName: string, email: string = ''): ActivateCardState => ({
    step: STEP_DATA,
    fullName: userName,
    email,
    cardNumber: '',
    confirmCardNumber: '',
    spendingLimit: String(DEFAULT_SPENDING_LIMIT * 100),
    spendingLimitDisplay: formatCurrency(DEFAULT_SPENDING_LIMIT, {
        currency: 'MXN',
        locale: 'es-MX',
    }),
    isEditingLimit: false,
    maxAvailableLimit: 0,
    isPendingApproval: false,
    isLoading: false,
    errors: {},
});


